export const ADD_TO_TAB = 'ADD_TO_TAB';
export const REMOVE_FROM_TAB = 'REMOVE_FROM_TAB';
export const SET_DASHBOARD_ACTIVE = 'SET_DASHBOARD_ACTIVE';
export const SET_TAB_ACTIVE = 'SET_TAB_ACTIVE';
export const SET_TAB_VIEW_NAME = 'SET_TAB_VIEW_NAME';
export const SET_TAB_LABEL = 'SET_TAB_LABEL';
export const SET_TAB_REFRESH = 'SET_TAB_REFRESH';
export const SET_PARAM = 'SET_PARAM';
export const AREA_LIST = 'AREA_LIST';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_SETTINGS = 'SET_SETTINGS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js